import React, { useEffect, useRef } from 'react';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import useIsBrowser from 'hooks/useIsBrowser';
import useCuralate from 'hooks/useCuralate';

const CRL8_CONTAINER_ID = 'homepage';

const HomepageCuralateGallery = ({ isAdmin }) => {
  const isBrowser = useIsBrowser();
  const { createExperience, destroyExperience } = useCuralate();
  const containerRef = useRef(null);

  // Capture the element in the effect body: by cleanup time React has
  // detached it and the ref may already be null.
  useEffect(() => {
    if (!isBrowser || isAdmin) return undefined;
    const container = containerRef.current;
    createExperience({ container });
    return () => destroyExperience({ container });
  }, [isBrowser, isAdmin, createExperience, destroyExperience]);

  if (isAdmin) {
    return (
      <AdminPlaceholder>“Homepage Curalate Gallery” component</AdminPlaceholder>
    );
  }

  if (!isBrowser) return null;

  return <div ref={containerRef} data-crl8-container-id={CRL8_CONTAINER_ID} />;
};

export default HomepageCuralateGallery;
